/**
 * The look of the "New workflow" flow — picker, composers and name forms —
 * matched to the redesigned screens (Workflows home DOP-624, deal screening
 * DOP-615/623, monitoring board DOP-625): dark-teal primary action, white
 * secondary with a grey border, ink-black titles, slate body text.
 *
 * Inputs keep a visible ring on focus: `@tailwindcss/forms` paints its own
 * box-shadow ring on every bare input, so colouring that ring is what leaves
 * exactly one (see NewDashboardModal).
 */

const BTN_BASE =
	"inline-flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-[10px] border px-4 text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782] disabled:cursor-not-allowed disabled:opacity-50";

export const BTN_PRIMARY = `${BTN_BASE} border-[#004C4B] bg-[#004C4B] text-white hover:bg-[#003a3a]`;

export const BTN = `${BTN_BASE} border-gray-200 bg-white font-medium text-[#1F2937] hover:bg-gray-50`;

/** A quiet text action: "Select all", "Back to workflow types". */
export const LINK =
	"inline-flex items-center gap-1.5 rounded text-[13px] font-medium text-[#004C4B] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#008782]";

export const CARD = "rounded-xl border border-gray-200 bg-white";

export const FIELD_LABEL = "text-[12.5px] font-semibold text-[#3f4247]";

export const INPUT =
	"w-full rounded-lg border border-[#d1d5db] bg-white px-3 py-2 text-sm text-[#111111] placeholder:text-[#9a9ea3] focus:outline-none focus:ring-1 focus:ring-[#004C4B]";

export const TITLE = "text-[15px] font-semibold text-[#111111]";

export const BODY = "text-[13px] leading-relaxed text-[#5B6472]";

export const HINT = "text-xs text-[#6B7280]";

/** A small label beside a title: how a workflow runs, or "Coming soon". */
export const PILL =
	"inline-flex h-[22px] items-center whitespace-nowrap rounded-full border border-gray-200 bg-white px-2 text-[11.5px] font-medium text-[#5B6472]";
